import React, { useEffect, useState } from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "../../../shared/components/skeletons/AutocompleteSkeleton";
import { finderSucursalByName } from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  procedimientosState,
  serviciosFetchState,
  serviciosState,
  sucursalesState,
  tipoExamenState,
} from "./state/atoms";

import {
  specialitiesByServiceState,
  specialitiesState,
  professionalsByServiceState,
  professionalsState,
} from "./state/atoms";
import procedimientoService from "src/services/agenda/procedimientos";
import TipoExamenService from "src/services/agenda/tipoExamen";
import useLoadData from "src/SearchHours/hooks/useLoadData";
import SucursalIcon from "src/shared/icons/SucursalIcon";

const AutocompleteSucursales = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loading, setLoading] = useState(false);
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const sucursales = useRecoilValue(sucursalesState);
  const [specialities, setSpecialities] = useRecoilState(specialitiesState);
  const [professionals, setProfessionals] = useRecoilState(professionalsState);
  const [servicios, setServicios] = useRecoilState(serviciosState);
  const [tipoExamen, setTipoExamen] = useRecoilState(tipoExamenState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState,
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState,
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const resetServicios = useResetRecoilState(serviciosState);
  const resetProcedimientos = useResetRecoilState(procedimientosState);

  const { loadData, loadingData } = useLoadData();

  const loadSpeciality = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          let sucursalCode = filterSearchSelected.sucursalSelected.code;
          let sue_correl = filterSearchSelected.sucursalSelected.sue_correl;
          let modalidad = filterSearchSelected.modalidadSelected.tipo;
          if (sue_correl != null) {
            const specialitiesFetch = snapshot.getPromise(
              specialitiesByServiceState({
                serviceCode: sucursalCode,
                modalidad,
                sueCorrel: sue_correl,
              }),
            );

            let obj = {
              codSpeciality: "0",
              sucursalCode,
              modalidad,
            };
            const professionalsFetch = snapshot.getPromise(
              professionalsByServiceState(obj),
            );

            const serviciosFetch =
              await procedimientoService.getServicios(sue_correl);

            const tipoExamenesFetch =
              await TipoExamenService.getAll(sue_correl);

            const responses = await Promise.all([
              specialitiesFetch,
              professionalsFetch,
            ]);

            setSpecialities(responses[0]);
            setProfessionals(responses[1]);
            setServicios(serviciosFetch.data.data);
            setTipoExamen(tipoExamenesFetch.data.data);
          }
          //else{
          //     setSpecialities([])
          //     setProfessionals([])
          // }
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [filterSearchSelected.sucursalSelected.value],
  );

  useEffect(() => {
    loadSpeciality();

    // return () => {
    //     loadSpeciality();
    // }
  }, [loadSpeciality]);

  // if (loading) return <AutocompleteSkeleton />;,

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-sucursal"
        text="Sucursal"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-sucursal"
        options={sucursales?.map((option) => `${option.sueNombre}`)}
        //options={sucursales.map((option) => `${option.serNombre}`)}
        getOptionLabel={(option) => option || null}
        value={filterSearchSelected.sucursalSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetProcedimientos();
          if (reason === "clear") {
            loadData(4);
            setFilterSearchSelected({
              ...filterSearchSelected,
              sucursalSelected: {
                ...filterSearchSelected.sucursalSelected,
                value: "",
                sue_correl: null,
                emp_codigo: null,
                cmn_nombre: null,
                code: null,
              },
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
              servicioSelected: {
                ...filterSearchSelected.servicioSelected,
                value: "",
                code: null,
              },
              procedimientoSelected: {
                ...filterSearchSelected.procedimientoSelected,
                value: "",
                code: null,
              },
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: "",
                code: null,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findSucursal = finderSucursalByName(sucursales, value);
            console.log("FIND SUCURSAL => ", findSucursal);

            setFilterSearchSelected({
              ...filterSearchSelected,
              sucursalSelected: {
                ...filterSearchSelected.sucursalSelected,
                value: value,
                code: findSucursal?.serCodigo,
                cmn_nombre: findSucursal?.cmnNombre,
                sue_correl: findSucursal?.sueCorrel,
                emp_codigo: findSucursal?.empCodigo,
              },
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
              servicioSelected: {
                ...filterSearchSelected.servicioSelected,
                value: "",
                code: null,
              },
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: "",
                code: null,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Sucursal" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <SucursalIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSucursales;
